import { RouterState } from 'connected-react-router';
import { updateIntl } from 'react-intl-redux';
import { Dispatch } from 'redux';

import { isProd, isStage } from '../../../config';
import { Locale } from '../../../models/locale.model';
import { getParameterByName } from '../../../utils';
import { MainStore } from '../../store';
import { setUrlHistory } from '../../ui';

export const beforeLocationChangeHandler = (
    store: MainStore,
    next: Dispatch,
    action: { payload: RouterState; type: string }
) => {
    const {
        intl: { locale },
        locales,
    } = store.getState();
    const langParam = getParameterByName('lang');
    const pathname = action.payload.location.pathname;
    const { hostname, pathname: pathnameWindow } = window.location;

    // Analytics code
    // For standalone react app dataLayer is set by GoogleTagManager component. For django embedded version it comes from django.
    if ((isProd || isStage || true) && pathname !== '/') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const layer = window.dataLayer;
        if (layer) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            layer.push({
                event: 'virtualPageView',
                virtualPageTitle: `${hostname}-${pathname.split('/')[1]}`,
                virtualPageURL: pathnameWindow,
            });
        }
    }

    // Language change
    if (!!langParam && langParam !== locale) {
        const languages = ['en', 'fr', 'it', 'de'];
        const messages = languages.indexOf(locale) >= 0 ? locales[langParam as Locale] : locales['de'];

        store.dispatch(updateIntl({ locale: langParam, messages }));
    }

    next(action);
};

export const afterLocationChangeHandler = (store: MainStore, action: { payload: RouterState }) =>
    store.dispatch(setUrlHistory(action.payload.location.pathname));

const routerHandlers = {
    '@@router/LOCATION_CHANGE': beforeLocationChangeHandler,
};

export const routerAfterHandlers = {
    '@@router/LOCATION_CHANGE': afterLocationChangeHandler,
};

export default routerHandlers;
